export function trim(str) {
  return String.prototype.trim.call(str);
}

export function isType(arg, type) {
  return Object.prototype.toString.call(arg) === "[object " + type + "]";
}

export function isWeixin() {
  return navigator.userAgent.toLowerCase().indexOf("micromessenger") !== -1;
}

export function parseQuery() {
  const res = {};

  const query = (location.href.split("?")[1] || "")
    .trim()
    .replace(/^(\?|#|&)/, "");

  if (!query) {
    return res;
  }

  query.split("&").forEach((param) => {
    const parts = param.replace(/\+/g, " ").split("=");
    const key = decodeURIComponent(parts.shift());
    const val = parts.length > 0 ? decodeURIComponent(parts.join("=")) : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res;
}

export function isLoopbackHost(host) {
  const h = String(host || "").toLowerCase();
  return h === "localhost" || h === "127.0.0.1" || h === "[::1]" || h === "::1";
}

export function stripWww(host) {
  return String(host || "")
    .toLowerCase()
    .replace(/^www\./, "");
}

export function sameSiteHost(hostA, hostB) {
  const a = stripWww(hostA);
  const b = stripWww(hostB);
  return a !== "" && a === b;
}

function normalizeEnvUrl(raw) {
  if (raw == null) {
    return "";
  }
  let s = String(raw).trim();
  if (!s || s === "undefined" || s === "null") {
    return "";
  }
  s = s.replace(/^['"]|['"]$/g, "").replace(/,+$/, "").trim();
  return s.replace(/\/+$/, "");
}

function hostnameOf(urlOrHost) {
  const s = String(urlOrHost || "").trim();
  if (!s) {
    return "";
  }
  try {
    if (/^https?:\/\//i.test(s)) {
      return new URL(s).hostname;
    }
    return new URL("http://" + s).hostname;
  } catch (e) {
    return s.split("/")[0].split(":")[0];
  }
}

/**
 * 接口根地址：
 * 本地 127.0.0.1 / localhost（含 Docker 8092）走相对路径，由 nginx / vue-cli 反代到 8083。
 * 线上 H5 与 PHP 同域，也走相对路径，避免写死 www、http/https、:8083。
 * 只有访问的域名和配置不一致时，才用绝对地址。
 */
function runtimeApiBase() {
  if (typeof window !== "undefined" && isLoopbackHost(window.location.hostname)) {
    return "";
  }
  const fromEnv = normalizeEnvUrl(process.env.VUE_APP_API_URL);
  if (!fromEnv) {
    return "";
  }
  if (typeof window !== "undefined") {
    const envHost = hostnameOf(fromEnv);
    if (
      isLoopbackHost(envHost) ||
      sameSiteHost(envHost, window.location.hostname)
    ) {
      return "";
    }
  }
  return fromEnv;
}

const VUE_APP_API_URL = runtimeApiBase();
const VUE_APP_WS_URL =
  normalizeEnvUrl(process.env.VUE_APP_WS_URL) ||
  (typeof location !== "undefined"
    ? `ws://${location.hostname}:20003`
    : "");

export { VUE_APP_API_URL, VUE_APP_WS_URL, hostnameOf };
